import axios from "axios";
import store from "redux/store";
import { SET_CURRENT_USER_DETAILS } from "actions/types";

async function getCurrentUser(idToken: string) {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_URL_API}/v1/users/current`,
      {
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
      }
    );

    store.dispatch({
      type: SET_CURRENT_USER_DETAILS,
      payload: response.data,
    });
    return response.data;
  } catch (err: any) {
    console.error(err);
  }
}

export default getCurrentUser;
